import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { Router, ActivatedRoute } from "@angular/router";
import { CountryService } from "../country.service";
import { Constants } from "../constants";
import { NgForm } from "@angular/forms";

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;
declare var moment: any;

@Component({
  selector: "app-card-payment",
  templateUrl: "./card-payment.component.html",
  styleUrls: ["./card-payment.component.css"],
})
export class CardPaymentComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  orderStatusArr = [
    { order_status: "All", order_value: "4" },
    {
      order_status: "Completed",
      order_value: "3",
      status_icon: "../../assets/greenCircle.svg",
    },
    { order_status: "Returned", order_value: "2" },
    {
      order_status: "Cancelled",
      order_value: "1",
      status_icon: "../../assets/redCircle.svg",
    },
    {
      order_status: "Pending",
      order_value: "0",
      status_icon: "../../assets/yellowCircle.svg",
    },
  ];
  paymentMethodArr = [
    {
      payment_method: "Online Payment",
      payment_value: "0",
      payment_icon: "../../assets/visaIcon.png",
    },
    {
      payment_method: "Cash on Delivery",
      payment_value: "1",
      payment_icon: "../../assets/cashIcon.png",
    },
    {
      payment_method: "Business Already Collected Payment",
      payment_value: "4",
      payment_icon: "../../assets/paymentAlreadyCollected.svg",
    },
  ];
  nao = new Nanobar();
  dispensary_name: any;
  activityList: any;
  available_balance: any;
  account_title = "";
  account_number = "";
  routing_number = "";
  bank_name = "";
  withdrawFee: any;
  routeNumChk = true;
  // for Order Detail Data
  orderDetailData: any;
  customerDetail: any;
  droppOffAddress: any;
  activityStatus2: any = "4";
  activityStatusVal: any = "All";
  paymentType: any;
  paymentTypeVal: any = "Payment Method";
  userDropDocs: any;
  orderDataDisplay: any;
  showRangePicker: boolean = false;
  pickupAddress: any;
  productData: any;
  onDetailDriverData: any;
  orderDetailToReopenOpId: any;
  transactionDetailData: any;
  transactionDetailDataSuccess: any;
  activitytype = "3";
  activityStatus = "4";
  dispensaryDetails: any;
  businessName = "Business Name";
  min_date: any = "";
  dispensary_id: any = -1;
  max_date: any = "";
  servicedetail: any;
  activityLimit = 200;
  detailStatus: any;
  pageNo: any;
  searcActivity = "";
  clearTimeout: any;
  noDataFound = false;
  paginatedDataActivity: any;
  activityPageCount = 0;
  activityLastPage = true;
  loadingData = true;
  returnOrderItems: any;
  returnOrderItemsLength: any;
  searchBusiness: any;
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private cs: CountryService
  ) {}

  transactionDetailPopOpen(id, status) {
    this.nao.go(30);
    this.dataService
      .getTransactionDetails(window.localStorage.getItem("token"), id)
      .subscribe(
        // , this.type, this.status, this.business_id
        (data) => {
          this.nao.go(100);
          this.detailStatus = status;
          this.transactionDetailData = data;
          this.transactionDetailDataSuccess =
            this.transactionDetailData.success;
          this.transactionDetailData =
            this.transactionDetailData.business_activity_dictionary;
          if (this.transactionDetailDataSuccess === true) {
            // if (status === 0 || status === 1 || status === 2 || status === 3 || status === 4 || status === 5 || status === 6) {
            $("#transactionDetailPop").modal("show");
            // } else {
            //     $('#rtgsPop').modal('show');
            //   }
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  addPaymentPopOpen() {
    this.account_title = "";
    this.account_number = "";
    this.routing_number = "";
    this.bank_name = "";
    this.routeNumChk = true;
    $("#addPaymentPop").modal("show");
  }

  reviewPopOpen() {
    $("#withdrawRequestPop").modal("hide");
    setTimeout(() => {
      $("#reviewPop").modal("show");
    }, 1000);
  }

  customValueSetter() {
    if (this.activitytype === "5") {
      this.showRangePicker = true;
      this.min_date = new Date().toISOString().split("T")[0];
      this.max_date = new Date().toISOString().split("T")[0];
    } else {
      this.showRangePicker = false;
      this.getBusinessActivityFunction();
      this.min_date = "";
      this.max_date = "";
    }
  }

  getDispensaryListing() {
    // console.log('e');
    this.dataService
      .getdispensaryListing(localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.dispensaryDetails = data;
          this.businessName = "Business Name";
          // this.orderslist(this.status);
          this.servicedetail = data;
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }

  orderStatus(status, id) {
    this.activityStatus2 = id;
    this.activityStatusVal = status;
    this.getBusinessActivityFunction();
  }

  paymentMethod(method, value) {
    if (value == "-1") {
      this.paymentTypeVal = "All";

      this.getBusinessActivityFunction();
    } else {
      this.paymentTypeVal = method;
      this.paymentType = value;
      this.getBusinessActivityFunction();
    }
  }

  getBusinessActivityFunction() {
    this.activityPageCount = 0;
    this.noDataFound = true;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // console.log("this.activitytype", this.activitytype);
      // console.log("this.activityStatus", this.activityStatus2);
      var type = parseInt(this.activitytype, 10);
      var status = parseInt(this.activityStatus2, 10);
      this.nao.go(30);
      this.dataService
        .getActivityByPage(
          window.localStorage.getItem("token"),
          type,
          status,
          this.min_date,
          this.max_date,
          this.dispensary_id,
          this.paymentType,
          this.searcActivity,
          this.pageNo
        )
        .subscribe(
          (data) => {
            // console.log(this.searcActivity);
            this.nao.go(100);
            this.noDataFound = false;
            this.activityList = data;
            this.available_balance = this.activityList.available_balance;
            // this.withdrawFee = this.activityList.fee;
            this.activityLastPage = this.activityList.last_page;
            this.activityPageCount++;
            this.activityList = this.activityList.items;
            this.loadingData = false;
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
            this.loadingData = false;
          }
        );
    }, 1000);
  }

  customDateFilter(event) {
    this.min_date = moment(event[0]).format("YYYY-MM-DD");
    this.max_date = moment(event[1]).format("YYYY-MM-DD");
    this.getBusinessActivityFunction();
  }

  getActivityByPageFunction() {
    let type = parseInt(this.activitytype, 10);
    let status = parseInt(this.activityStatus, 10);
    this.nao.go(30);
    this.dataService
      .getActivityByPage(
        window.localStorage.getItem("token"),
        type,
        status,
        this.min_date,
        this.max_date,
        this.dispensary_id,
        this.paymentType,
        this.searcActivity,
        this.activityPageCount
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginatedDataActivity = data;
          // this.limit = this.paginatedData.limit;
          this.activityLastPage = this.paginatedDataActivity.last_page;
          this.activityPageCount++;
          this.paginatedDataActivity = this.paginatedDataActivity.items;
          for (var i = 0; i < this.paginatedDataActivity.length; i++) {
            this.activityList.push(this.paginatedDataActivity[i]);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  orderDetailCall(id) {
    this.orderDetailToReopenOpId = this;
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.orderDetailData = data;
          this.customerDetail = this.orderDetailData.customer_detail;
          this.droppOffAddress = this.orderDetailData.dropoff_address;
          this.userDropDocs = this.orderDetailData.drop_off_docs;
          this.orderDataDisplay = this.orderDetailData.order;
          this.pickupAddress = this.orderDetailData.pickup_address;
          this.productData = this.orderDetailData.product;
          this.onDetailDriverData = this.orderDetailData.driver;
          this.returnOrderItems =
            this.orderDataDisplay.return_items["return_product_list"];
          this.returnOrderItemsLength = this.returnOrderItems.length;
          console.log("this.onDetailDriverData", this.onDetailDriverData);
          $("#orderDetailPopReport").modal("show");
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  clearSearch() {
    this.searcActivity = "";
    this.getBusinessActivityFunction();
  }
  filterBusinessId(id, name, detail) {
    this.dispensary_id = id;
    this.businessName = name;
    // console.log(this.dispensary_id);
    // console.log(this.businessName);
    this.getBusinessActivityFunction();
    // this.getActivityByPageFunction();

    // if (this.dispensary_id == -1) {
    //   this.businessName = "All Businesses";
    // }

    // if (this.dispensary_id != -1) {
    //   this.businessName = name;
    // }
  }
  ngOnInit() {
    this.getBusinessActivityFunction();
    this.getDispensaryListing();
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#payments").css("color", "#d77229");
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $("#sidebar").css("display", "block");
  }
}



// WEBPACK FOOTER //
// ./src/app/card-payment/card-payment.component.ts